<template>
  <div id="subpage">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <b>首页</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item>我的课程</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <div class="content">
      <div class="xcx-head">
        <div style="display: flex">
          <span>课程列表</span>
        </div>
      </div>

      <div class="search-box mt10 mb10">
        <el-row>
          <el-button @click="changeColumn(0)" :type="column_id == 0 ? primary : ''">全部</el-button>
          <el-button @click="changeColumn(o.column_id)" :type="column_id == o.column_id ? primary : ''"
            v-for="(o, index) in columnData" :key="index">{{
              o.column_name
            }}</el-button>
        </el-row>
      </div>

      <div class="xcx-content">
        <el-empty :image-size="200" v-if="tableData.length == 0" description="还未开通任何课程……"></el-empty>
        <!--列表-->
        <el-row :gutter="20">
          <el-col :span="3" v-for="(o, index) in tableData" :key="index" class="mb20" :offset="index > 0 ? 0 : 0">
            <el-card :body-style="{ padding: '0px' }" class="cur_p">
              <img :src="o.thumb" class="image" @click="goDetails(o.course_id)">
              <div style="padding:7px 14px;" @click="goDetails(o.course_id)">
                <span>{{ o.title }}</span>
                <div class="bottom clearfix">
                  <time class="time">{{ o.apply_num }} 人学习</time>
                  <div type="text" class="button">{{ o.total }} 课时</div>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
        <!--分页-->
        <div class="paging">
          <el-pagination class="left" :page-size="limit" @current-change="handleCurrentChange" :current-page="page"
            background layout="total, prev, pager, next" :total="count"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: true,
      tableData: [],
      columnData: [],
      page: 0,
      count: 0,
      limit: 16,
      primary: "primary",
      column_id: 0,
    };
  },
  //进入页面加载
  mounted: function () {
    var that = this;
    that.getList();
    that.getMyColumn();
  },
  methods: {
    changeColumn(ids) {
      var that = this;
      that.column_id = ids;
      that.getList();
    },
    goDetails(ids) {
      this.$router.push({
        path: "/course/details",
        query: {
          id: ids,
        },
      });
    },
    getMyColumn() {
      var that = this;
      that.axios
        .post("/getMyColumn")
        .then((res) => {
          that.columnData = (res && res.data) || [];
        })
        .catch(() => {
          that.columnData = [];
        });
    },
    /**
     * 下一页
     */
    handleCurrentChange(currentPage) {
      var that = this;
      that.page = currentPage;
      that.getList();
    },

    /**
     * 获取列表
     */
    getList() {
      let that = this;
      let formData = {};
      var curr_page = sessionStorage.getItem("curr_page");
      that.page = curr_page ? curr_page - 0 : that.page;
      formData.page = that.page;
      formData.column_id = that.column_id;
      formData.limit = that.limit;
      that.axios
        .post("/getMyCourse", formData)
        .then((res) => {
          const data = (res && res.data) || {};
          that.tableData = data.data || [];
          that.count = data.total || 0;
          that.page = curr_page ? curr_page : that.page;
          curr_page ? sessionStorage.removeItem("curr_page") : "";
        })
        .catch(() => {
          that.tableData = [];
          that.count = 0;
        })
        .finally(() => {
          that.loading = false;
        });
    },
  },
};
</script>
<style>
.search-box {
  padding: 0 20px;
}

.time {
  font-size: 13px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.button {
  padding: 0;
  float: right;
  font-size: 14px;
  color: #999;
}

.image {
  width: 183px;
  height: 214px;
  display: block;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.el-card span {
  font-size: 12px;
  font-weight: bold;
  width: 100%;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 36px;
}
</style>